import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../error/err.service';
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { RESTAPI } from '../shared/stateapimanagement/apiwithoutstate';
import { formatDate } from '@angular/common';
import * as echarts from 'echarts';
import { takeUntil } from 'rxjs/operators';
import { TimeZoneService } from './time-zone.service';
import { LongPollingStatelessProgress } from '../shared/stateapimanagement/longpollingstateless-progress';
import { SharedService } from './shared.service';
import { ToastService } from '../shared/custom-overlay/toast/toast.service';



@Injectable({
  providedIn: 'root'
})
export class DashboardService {
// Need to remove as per shared service
  headers = new HttpHeaders({ 'content-type': 'application/json', 'charset': 'utf-8' });
  private designerDetails: Array<any> = [];
  private designerInit;

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private errorservice: ErrorService,
    private timeZoneService: TimeZoneService,
    private toastService: ToastService
  ) { }
  filterOption: any[] = [];
  

    // Function to group data based on the selected option
  getFilteredOption() {
      this.filterOption = [
          { "label": "Group By Platform", "value": "platform_disp" },
          { "label": "Group By Type", "value": "dashboard_type" }
      ];
      return this.filterOption;
  }

  groupByOption: string = 'platform_disp'; 
  componentdestroyed: Subject<number> = new Subject()
  dashboardLandingData:any;
  $dashboardLandingdestroy:Subject<boolean> = new Subject()
  timeformat:string = "YYYY-MM-DD HH:mm:ss"
  pipelineStatsData:any;
  public $showDashbordTableView:BehaviorSubject<string> = new BehaviorSubject('');

  defaultDate = this.sharedService.metaData.dashboard.dateFilter_default.default_fromDt
  userTimeZone =JSON.parse(JSON.stringify(this.sharedService.timeZone))
  defaulttimerange:any;
  
  requesttimerange:any;
  destroyobs:Subject<number> = new Subject()

  customSubtitle(sub: string, fromdate, todate, numDays) {

    let subtitle=""

    // if (sub) {
      sub = ""
      switch (true) {
        case (numDays == undefined || (fromdate && todate)):
          subtitle = sub + ` ` + `custom   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
          break;
        case (numDays == 1):
          subtitle = sub + ` ` + ` yesterday` + `   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
          break;
        case (numDays == 0):
          subtitle= sub + ` ` + ` today` + `   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
          break;
        default:
          subtitle = sub + ` ` + ` past ${numDays + 1} days` + `   ( ${formatDate(fromdate, 'd MMM', 'en-US')}  to  ${formatDate(todate, 'd MMM', 'en-US')} )`;
      }

    // }
    console.log("Subtitle->",subtitle)
    return subtitle
    // this.CustomFilterSub = ''
  }

  getdashboardlanding = new LongPollingStatelessProgress(
    this.getDashboardLanding,
    this.http,
    this.sharedService.userLoggedoff_,
    this.errorservice,
    '/dashboard/widgets/get',
    'Dashboard',
    this.toastService
  )

  getDashboardLanding(reqwidgetdetails:any){
    return this.http.post<any>(environment.apiUrl + '/dashboard/widgets/get', reqwidgetdetails, {headers: this.headers})
  }

  getwidgetlabel = (() => {

    return new RESTAPI(
      this.getWidgetLabel,
      this.http,
      this.sharedService.userLoggedoff_,
      this.errorservice,
      // 'dashboard/widget/label/get',
      'dashboard/widgets/get',
      'Dashboard',
      this.toastService
    )

  })
  getWidgetLabel(widgetName: any) {
    // return this.http.post<any>(environment.apiUrl + '/dashboard/widget/label/get', widgetName, { headers: this.headers })
    return this.http.post<any>(environment.apiUrl + '/dashboard/widgets/get', widgetName, { headers: this.headers })

  }

  getwidgetTable = (() => {
    return new RESTAPI(
      this.getWidgetTable,
      this.http,
      this.sharedService.userLoggedoff_,
      this.errorservice,
      // '/dashboard/widget/table/get',
      '/dashboard/widgets/get',
      'Dashboard',
      this.toastService
    )

  })
  getWidgetTable(requestObj: any) {
    // return this.http.post<any>(environment.apiUrl + '/dashboard/widget/table/get', requestObj, { headers: this.headers })
      return this.http.post<any>(environment.apiUrl + '/dashboard/widgets/get', requestObj, { headers: this.headers })

  }


  getwidgetchart = (() => {
    return new RESTAPI(
      this.getWidgetChart,
      this.http,
      this.sharedService.userLoggedoff_,
      this.errorservice,
      // 'dashboard/widget/chart/get',
      'dashboard/widgets/get',
      'Dashboard',
    this.toastService
    )
  })
  getWidgetChart(requestObj: any) {
    return this.http.post<any>(environment.apiUrl + '/dashboard/widgets/get', requestObj, { headers: this.headers })

    // return this.http.post<any>(environment.apiUrl + '/dashboard/widget/chart/get', requestObj, { headers: this.headers })
    //return this.http.post<any>('http://172.104.161.195:3006' + '/dashboard/widget/chart/get', requestObj, { headers: this.headers })
  }

  getStudioList(designReq): any {
    let request = JSON.stringify(designReq);
    return this.http.post<any>(environment.apiUrl + '/studio/list/get', request, { headers: this.headers })
  }

  getDashboardList(designReq:any){
    
    let request = JSON.stringify(designReq);
    return this.http.post<any>(environment.apiUrl + '/dashboard/dashboard_list/get', request, { headers: this.headers })
  }

  getTemplates(): any {
    let request = JSON.stringify({ "template_list": "all" });
    return this.http.post<any>(environment.apiUrl + '/studio/templates/get', request, { headers: this.headers })

  }
  postTemplates(templateObj) {
    let request = templateObj;
    return this.http.post<any>(environment.apiUrl + '/studio/template/post', request, { headers: this.headers })
  }
  getWidgetList(): any {
    let request = JSON.stringify({ "widgetType": "all" });
    return this.http.post<any>(environment.apiUrl + '/studio/widget_list/get', request, { headers: this.headers })
  }
  getstudioPreview(designId): any {
    let request = JSON.stringify({ "design_id": designId });
    return this.http.post<any>(environment.apiUrl + '/studio/preview/get', request, { headers: this.headers })
  }
  getstudioDelete(designId,designType:string): any {
    let request = { "design_id": designId, designType };
    if(designType == "Widget"){
      return this.http.post<any>(environment.apiUrl + '/studio/widget/delete', request, { headers: this.headers })
    } else {
        return this.http.post<any>(environment.apiUrl + '/studio/delete', request, { headers: this.headers })
    }
  }
  postStudio(design) {
    let request = JSON.stringify(design);
    return this.http.post<any>(environment.apiUrl + '/studio/new/post', request, { headers: this.headers })
  }
  editPostStudio(design) {
    let request = JSON.stringify(design);
    return this.http.post<any>(environment.apiUrl + '/studio/edit/post', request, { headers: this.headers })
  }

  getWidgetbuilder_edit(widget_details:any){
    const reqobj = JSON.stringify(widget_details);
    return this.http.post<any>(environment.apiUrl + '/studio/widget-builder/widget/edit/get', reqobj, { headers: this.headers })
  }

  widgetpreviewDestroyed:Subject<number> = new Subject();
  getWidgetPreview = new LongPollingStatelessProgress(
    this.getwidgetpreview,
    this.http,
    this.sharedService.userLoggedoff_,
    this.errorservice,
    // '/dashboard/widget/chart/get',
    '/dashboard/widgets/get',
    'studio',
    this.toastService
  );

  getwidgetpreview(reqobj:any){
    // return this.http.post(environment.apiUrl+'/dashboard/widget/chart/get',reqobj,{ headers: this.headers })
    return this.http.post(environment.apiUrl+'/dashboard/widgets/get',reqobj,{ headers: this.headers })

  }

  getCollectiveDashbordTemplate(design_name:string){
//console.log('/studio/collective_preview/get, design_name==',design_name);
    
    return this.http.post(environment.apiUrl+'/studio/collective_preview/get',JSON.stringify({design_name:design_name}),{ headers: this.headers })
  }



  //to calculate the timerange from the relative time
  timeRangeCalc(input) {
    let userCurrentTime = this.timeZoneService.getcurrentuserTime()
    
    if (input[0] == '-' && input[1] == 'minute') {
      return [userCurrentTime.clone().subtract(input[2],'minute').format(this.timeformat),userCurrentTime.format(this.timeformat)];
    }
    else if (input[0] == '-' && input[1] == 'hour') {
      return [userCurrentTime.clone().subtract(input[2],'hour').format(this.timeformat),userCurrentTime.format(this.timeformat)];
    }
    else if (input[0] == '-' && input[1] == 'day') {
      return [userCurrentTime.clone().subtract(input[2],'days').startOf('D').format(this.timeformat),userCurrentTime.format(this.timeformat)];
    }
    else if (input[0] == '*' && input[1] == 'day') {
      let newDate = userCurrentTime.clone().subtract(input[2],'days');
      if(input[2] == 0){
        return [newDate.clone().startOf('D').format(this.timeformat),userCurrentTime.format(this.timeformat)];
      } else {
        return [newDate.clone().startOf('D').format(this.timeformat), newDate.clone().endOf('D').format(this.timeformat)];
      }
    }
    else if (input[0] == '-' && input[1] == 'week') {
      let previousWeeks = userCurrentTime.clone().subtract(input[2],'weeks');

      if (input[2] == 0) {
        return [previousWeeks.startOf('week').format(this.timeformat),userCurrentTime.format(this.timeformat)];
      } else{
        return [previousWeeks.startOf('week').format(this.timeformat),previousWeeks.endOf('week').format(this.timeformat)];
      }      
    }
    else if (input[0] == '-' && input[1] == 'month') {
      return [userCurrentTime.clone().subtract(input[2],'months').format(this.timeformat),userCurrentTime.format(this.timeformat)];
    }
    else if (input[0] == '-' && input[1] == 'year') {
      return [userCurrentTime.clone().subtract(input[2],'year').format(this.timeformat),userCurrentTime.format(this.timeformat)];
    }
    else return [formatDate(input[0], this.timeformat, 'en-US'), formatDate(input[1], this.timeformat, 'en-US')]
  }


  getAlertCountChartdata(data:any){
    const alert_days = Object.keys(data).map((key)=> this.timeZoneService.toUserTimeZone(parseInt(key)).format('MMM DD HH:mm'));
    const alert_cnt = Object.values(data)
    return {"alert_cnt":alert_cnt,"alert_days":alert_days}
  }


  enumerateDaysBetweenDates = function(startDate, endDate) {
    var dates = [];
    var currDate = startDate.clone()
    var lastDate = endDate.clone()
    dates.push(currDate.format('dddd'))
    while(currDate.add(1, 'days').diff(lastDate) <= 0) {
      dates.push(currDate.format('dddd'));
    }
    return dates;
  };

  getGaugeGradeFormater(){
    return function (val:any) {
      if (val === 100) {
        return 'Low(0-10%)';
      } else if (val === 300) {
        return 'Medium(11%-50%)';
      } else if(val === 700){
        return 'High(51%-100%)';
      }
      return ''
    }
  }

  getGaugeGradeValueFormater(value:number){
    if (value >= 1000000000000) {
      return (value / 1000000000000).toFixed(1) + 'T'; // Trillion
    } else if (value >= 1000000000) {
      return (value / 1000000000).toFixed(1) + 'B'; // Billion
    } else if (value >= 1000000) {
      return (value / 1000000).toFixed(1) + 'M'; // Million
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1) + 'K'; // Thousand
    } else {
      return value; // If it's less than 1000, return the value as is
    }
  }


  sizeFormater(){
    return function (value) {
      if (value === 0) return '0 B';
      const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(value) / Math.log(1024));
      const scaled = value / Math.pow(1024, i);
      return scaled.toFixed(1).replace(/\.0$/, '') + ' ' + units[i];
    }
  }

  legentFormaterFuncation(data,mode){
    const fmn= this.getFormateNumber()
    const fmnSize = this.getFormaterSize()
    return function (name) {
      let seriesData = data;  // Get the latest data from the chart
      let item = seriesData.find(d => d.name === name);  // Find the matching item
      let total = seriesData.reduce((sum, d) => sum + d.value, 0);
      // return item ? `${(item.value / total * 100).toFixed(2)}%   ${name}` : name;
      if(mode ==1 ){
        return item ? `${fmnSize(item.value)}   ${name}` : name;
      }
      else{
        return item ? `${fmn(item.value)}   ${name}` : name;
      }

    }
  }


  tooltipsizeFormater(){
    return function (params) {
      const value = params.value;
    if (value === 0) return `${params.name}: 0 B`;

    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(value) / Math.log(1024));
    const scaled = value / Math.pow(1024, i);
    const formattedValue = scaled.toFixed(1).replace(/\.0$/, '') + ' ' + units[i];

    return `${params.name}: <span style="font-weight: bold;">${formattedValue}</span>`;
    }
  }

  areaStacktooltipsizeFormater(){
    return function (params) {
      let tooltipText = params[0].axisValue + '<br/>';
      params.forEach(item => {
        let value = item.value
        if(value == 0){
          let valueGB =  '0 B'; 
          tooltipText += `${item.marker} ${item.seriesName}: <span style="font-weight: bold;"> ${valueGB}</span><br/>`;
        }
        else{
          const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
          const i = Math.floor(Math.log(value) / Math.log(1024));
          const scaled = value / Math.pow(1024, i);
          const formattedValue = scaled.toFixed(1).replace(/\.0$/, '') + ' ' + units[i];
          tooltipText += `${item.marker} ${item.seriesName}: <span style="font-weight: bold;">${formattedValue}</span><br/>`;
        }
      });
    return tooltipText;
    }
  }

  barStackTooltipNumberFormatter(){
    const fmn =this.getFormateNumber()
    return function (params){
      let name=`<span style="font-weight: bold;">${params[0].name} </span><br\>`;
      params.forEach(data=>{
        name += `${data.marker} ${data.seriesName} : <span style="font-weight: bold;"> ${fmn(data.value)} </span><br/>`;
      });
      return name;
    }
  }

  barStackTooltipSizeFormatter(){
    const fmn =this.getFormaterSize()
    return function (params){
      let name=`<span style="font-weight: bold;">${params[0].name} </span><br\>`;
      params.forEach(data=>{
        name += `${data.marker} ${data.seriesName} : <span style="font-weight: bold;"> ${fmn(data.value)} </span><br/>`;
      });
      return name;
    }
  }
  

  areaStacktooltipNumberFormater(){
    const fmn= this.getFormateNumber()
    
    return function (params) {
      let tooltipText = params[0].axisValue + '<br/>';
      params.forEach(item => {
        let value = item.value
        
        tooltipText += `${item.marker} ${item.seriesName}: <span style="font-weight: bold;"> ${fmn(value)}</span><br/>`;
        
      });
    return tooltipText;
    }
  }

  formatValue(value){
    const abs = Math.abs(value);

    if (abs >= 1e33) {
      return (value / 1e33).toFixed(1).replace(/\.0$/, '') + 'Dc';
    } else if (abs >= 1e30) {
      return (value / 1e30).toFixed(1).replace(/\.0$/, '') + 'No';
    } else if (abs >= 1e27) {
      return (value / 1e27).toFixed(1).replace(/\.0$/, '') + 'Oc';
    } else if (abs >= 1e24) {
      return (value / 1e24).toFixed(1).replace(/\.0$/, '') + 'Sp';
    } else if (abs >= 1e21) {
      return (value / 1e21).toFixed(1).replace(/\.0$/, '') + 'Sx';
    } else if (abs >= 1e18) {
      return (value / 1e18).toFixed(1).replace(/\.0$/, '') + 'Qi';
    } else if (abs >= 1e15) {
      return (value / 1e15).toFixed(1).replace(/\.0$/, '') + 'Qa';
    } else if (abs >= 1e12) {
      return (value / 1e12).toFixed(1).replace(/\.0$/, '') + 'T';
    } else if (abs >= 1e9) {
      return (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
    } else if (abs >= 1e6) {
      return (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (abs >= 1e3) {
      return (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
    }
      //  else if(chart_type == "polar_tangential_bar" && value == 0){
      //   return ""
      // } 
      else {
        return value; 
      }
  }

  // return formater function for axis lable
  getFormaterFunction(chart_type?:string){
    return function (value) {
      const abs = Math.abs(value);

    if (abs >= 1e33) {
      return (value / 1e33).toFixed(1).replace(/\.0$/, '') + 'Dc';
    } else if (abs >= 1e30) {
      return (value / 1e30).toFixed(1).replace(/\.0$/, '') + 'No';
    } else if (abs >= 1e27) {
      return (value / 1e27).toFixed(1).replace(/\.0$/, '') + 'Oc';
    } else if (abs >= 1e24) {
      return (value / 1e24).toFixed(1).replace(/\.0$/, '') + 'Sp';
    } else if (abs >= 1e21) {
      return (value / 1e21).toFixed(1).replace(/\.0$/, '') + 'Sx';
    } else if (abs >= 1e18) {
      return (value / 1e18).toFixed(1).replace(/\.0$/, '') + 'Qi';
    } else if (abs >= 1e15) {
      return (value / 1e15).toFixed(1).replace(/\.0$/, '') + 'Qa';
    } else if (abs >= 1e12) {
      return (value / 1e12).toFixed(1).replace(/\.0$/, '') + 'Tn';
    } else if (abs >= 1e9) {
      return (value / 1e9).toFixed(1).replace(/\.0$/, '') + 'Bn';
    } else if (abs >= 1e6) {
      return (value / 1e6).toFixed(1).replace(/\.0$/, '') + 'Mn';
    } else if (abs >= 1e3) {
      return (value / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    else {
      return value; 
    }
    }
  }

  getFormaterSize(){
      return function (value) {
      if (value === 0) return '0 B';
      const units = [' B', ' KB', ' MB', ' GB', ' TB', ' PB', ' EB', ' ZB', ' YB'];
      const i = Math.floor(Math.log(value) / Math.log(1024));
      const scaled = value / Math.pow(1024, i);
      const formattedValue = scaled.toFixed(1).replace(/\.0$/, '') + ' ' + units[i];
  
      return formattedValue
      }
  }

  getTooltipFormater(chart_type:string,isDataColBytes){
    const fmn = this.getFormateNumber()
    const fmnSize = this.getFormaterSize()
    return function(params) {
      // console.log(params)
      let params_name = params.name;
      let params_value = params.value;
      if (chart_type == "heatmap") {
        params_value = params.value[2];
      } else if (chart_type == "horizontal_bar") {
        params_value = params.value[0];
      }  
      else if (chart_type == 'barStack'){
       
        params_name = params[0].seriesName;
        params_value = params[0].value;

      }
      else if (chart_type == "large_area_chart" || chart_type == "areaStack" || chart_type == 'lineStack' ||   chart_type == 'customlinebar' || chart_type == 'customlinearea') {
        // console.log(params)
       
        params_name = params[0].name;
        params_value = params[0].value;
      }
      if(chart_type=="customlinearea" || chart_type=="customlinebar"){
          let tooltip='';
          params.forEach((item: any) => 
          {
            if (item.seriesName === 'Data') {
              // console.log(item.seriesName,"item")
              tooltip+=`${params_name}: <span style="font-weight: bold">${fmnSize(params_value)}</span>`
            } 
            else if (item.seriesName === 'Percentage') {
              // console.log(item.seriesName,"item")
              tooltip+=`${params_name}: <span style="font-weight: bold">${params_value} %</span>`
            }
            else{
              tooltip+=`${params_name}: <span style="font-weight: bold">${fmn(params_value)}</span>`
            }
          });
          return tooltip;
      }
      // console.log(chart_type,isDataColBytes,params)
      else{
        if(isDataColBytes == 1){
          return `${params_name}: <span style="font-weight: bold">${fmnSize(params_value)}</span>`;
        }
        else{
          return `${params_name}: <span style="font-weight: bold">${fmn(params_value)}</span>`;
        }
      }
      
    }
  }
  
  //return formater function for tootip
  getFormateNumber(){
    return function (value){
      const abs = Math.abs(value);

      if (abs >= 1e33) {
        return (value / 1e33).toFixed(1).replace(/\.0$/, '') + ' Dc';
      } else if (abs >= 1e30) {
        return (value / 1e30).toFixed(1).replace(/\.0$/, '') + ' No';
      } else if (abs >= 1e27) {
        return (value / 1e27).toFixed(1).replace(/\.0$/, '') + ' Oc';
      } else if (abs >= 1e24) {
        return (value / 1e24).toFixed(1).replace(/\.0$/, '') + ' Sp';
      } else if (abs >= 1e21) {
        return (value / 1e21).toFixed(1).replace(/\.0$/, '') + ' Sx';
      } else if (abs >= 1e18) {
        return (value / 1e18).toFixed(1).replace(/\.0$/, '') + ' Qi';
      } else if (abs >= 1e15) {
        return (value / 1e15).toFixed(1).replace(/\.0$/, '') + ' Qa';
      } else if (abs >= 1e12) {
        return (value / 1e12).toFixed(1).replace(/\.0$/, '') + ' Tn';
      } else if (abs >= 1e9) {
        return (value / 1e9).toFixed(1).replace(/\.0$/, '') + ' Bn';
      } else if (abs >= 1e6) {
        return (value / 1e6).toFixed(1).replace(/\.0$/, '') + ' Mn';
      } else if (abs >= 1e3) {
        return (value / 1e3).toFixed(1).replace(/\.0$/, '') + ' K';
      }
      else {
        return value; 
      }
    }
  }
  
  tableFormateNumber(evt_cnt){
    const fmn = this.getFormateNumber() 
    return fmn(evt_cnt)
  }

  
  

  getCustomPolarHeatmapChartdata(chartdata:any){
    const data = []
    let start_dt = this.timeZoneService.toUserTimeZone(chartdata[1][0]).startOf('D');
    let end_dt = this.timeZoneService.toUserTimeZone(chartdata[1][1]).startOf('D');
    let end_dt_end_of_day = this.timeZoneService.toUserTimeZone(chartdata[1][1]).endOf('D');
    const days = this.enumerateDaysBetweenDates(start_dt,end_dt)
    let start_time =  parseInt(Object.keys(chartdata[0])[0])-3600
    let end_time =  parseInt(Object.keys(chartdata[0])[Object.keys(chartdata[0]).length-1])+3600

    while(start_time >= start_dt.unix()){
      chartdata[0][start_time] = -1
      start_time -= 3600
    }


    while(end_time < end_dt_end_of_day.unix()){
      chartdata[0][end_time] = -1
      end_time += 3600
    }

    for (const [ts, cnt] of Object.entries(chartdata[0])){
      let dt_object = this.timeZoneService.toUserTimeZone(parseInt(ts));

      let event_time_round_start_day = dt_object.clone().startOf('D');

      let daysdifference = event_time_round_start_day.diff(start_dt, 'days');

      data.push([daysdifference,dt_object.hour(),chartdata[0][ts]]);
    }

    const renderfn = function (params:any, api:any) {
                  var values = [api.value(0), api.value(1)];
                  var coord = api.coord(values);
                  var size = api.size([1, 1], values);
                  return {
                    type: 'sector',
                    shape: {
                      cx: params.coordSys.cx,
                      cy: params.coordSys.cy,
                      r0: coord[2] - size[0] / 2,
                      r: coord[2] + size[0] / 2,
                      startAngle: -(coord[3] + size[1] / 2),
                      endAngle: -(coord[3] - size[1] / 2)
                    },
                    style: api.style({
                      fill: api.value(2) <= 0 ? '#FFFFFF' : api.visual('color')
                    })
                  };
                }

    if(data) {
      const maxvalue = data.reduce(function (max, item:any) {
        return Math.max(max, item[2]);
      }, -Infinity);

      return {
        "maxvalue":maxvalue,
        "renderitem":renderfn,
        "data":data,
        "days":days
      };
    } 
  }


  getPolarBarChartformatter(data,eventIds){    
    return function (params:any) {
      const id = params.dataIndex;
      return (
        eventIds[id] +
        '<br>Lowest：' +
        data[id][0] +
        '<br>Highest：' +
        data[id][1] +
        '<br>Average：' +
        data[id][2]
      );
    }
  }


    getcustomPolarheatmapChartformatter(days,data){ 
      const fmn = this.getFormateNumber()  
      return function (params:any) {
        const id = params.dataIndex;
        if(data[id][2] < 0){
          return (
            days[data[id][0]] +
            '<br>Hour：' +
            data[id][1] +
            '<br>Out of range'
          ); 
        } else {
          return (
            days[data[id][0]] +
            '<br>Hour：' +
            data[id][1] +
            '<br>Count：' +
            `<strong>${fmn(data[id][2])}</strong>`
          ); 
        }
      }
    }

    getCustomPolarHeatmap2formatter(){
      return function (params:any, api:any) {
        var values = [api.value(0), api.value(1)];
        var coord = api.coord(values);
        var size = api.size([1, 1], values);
        return {
          type: 'sector',
          shape: {
            cx: params.coordSys.cx,
            cy: params.coordSys.cy,
            r0: coord[2] - size[0] / 2,
            r: coord[2] + size[0] / 2,
            startAngle: -(coord[3] + size[1] / 2),
            endAngle: -(coord[3] - size[1] / 2)
          },
          style: api.style({
            fill: api.value(2) <= 0 ? '#FFFFFF' : api.visual('color')
          })
        };
      }
    }
  
    getcustomPolarheatmap2tooltipformatter(days,items,data){   
      const fmn = this.getFormateNumber()
      return function (params:any) {
        const id = params.dataIndex;
        if(data[id][2] < 0){
          return (
            days[data[id][0]] +
            '<br>Hour：' +
            items[data[id][1]] +
            '<br>Out of range'
          ); 
        } else {
          return (
            days[data[id][0]] +
            '<br>Hour：' +
            items[data[id][1]] +
            '<br>Count：' +
            `<strong>${fmn(data[id][2])}</strong>`
          ); 
        }
      }
    }

    getPolarBarChartSeries(series:any,data:any){
      series[0].data = data.map(function (d) {
        return d[0];});

      series[1].data = data.map(function (d) {
        return d[1] - d[0];
      });

      series[2].data = data.map(function (d) {
        return d[2];
      });

      series[3].data = data.map(function (d) {
        if (d[1] == d[0]){
          return d[1];
        } else {
          return Math.max((d[1] - d[2])/3 ,1);
        }
      });
      return series;
    }

    getTreemapChartformater(){
      const formatUtil = echarts.format;
      const fmn = this.getFormateNumber() 
      return function (info:any) {
        var value = info.value;
        var treePathInfo = info.treePathInfo;
        var treePath = [];
        for (var i = 1; i < treePathInfo.length; i++) {
          treePath.push(treePathInfo[i].name);
        }
        return [
          '<div class="tooltip-title">' +
            formatUtil.encodeHTML(treePath.join('/')) +
            '</div>',
          'Count: ' + `<strong>${fmn(value)}</strong>`
        ].join('');
      }
    }

     async requestDashboardData(requestObj){
//conso;e.log({requestObj})
      await this.getdashboardlanding.postrequest(requestObj).pipe(takeUntil(this.$dashboardLandingdestroy)).subscribe((data)=>{
        this.dashboardLandingData = data
      },
      (err)=>{
        this.dashboardLandingData = err
      })
      
    }

    cleardashboarddata() {
      this.dashboardLandingData = "";
    }
    createDashboardreqobj(previewDivs:any,dashboard_landing_mode:boolean,refresh_mode:boolean){
//conso;e.log({previewDivs})
      let requestObj = {}
      let widgetkeys=[]
      // requestObj = {"dashboard_landing":dashboard_landing_mode,"hosts":["all"],"userTimeZone":this.userTimeZone,"timeRange":this.requesttimerange}
      requestObj = {"dashboard_landing":dashboard_landing_mode,"refresh":refresh_mode,"userTimeZone":this.userTimeZone,"timeRange":this.requesttimerange}
      let widgets = {}
      for(let obj of previewDivs) {
        if(obj.widgetName != null) {
          let widgetkey = obj.widgetName 
          widgetkeys.push(widgetkey)
        }
      }
      requestObj["widgetkeys"] = widgetkeys;
      requestObj['time_zone_difference']=this.timeZoneService.getcurrentuserTime().utcOffset() * 60
      if(requestObj["widgetkeys"].length){
        
        this.requestDashboardData(requestObj);
      }
    }
  
    createTimerange(){
      var timerange = this.timeRangeCalc(this.defaultDate);
      var utctimerange:any = [this.timeZoneService.toUtcTimeZonefromUser(timerange[0]).format(this.timeformat),this.timeZoneService.toUtcTimeZonefromUser(timerange[1]).format(this.timeformat)];
      this.defaulttimerange = utctimerange[1].slice(0,10)
      this.requesttimerange =  [...utctimerange]
    }

    create_request_object_dashboard_widgets(previewDivs){
      this.createTimerange()
      this.createDashboardreqobj(previewDivs,true,false)
      return this.defaulttimerange
    }
    create_request_object_widgets(previewDivs){
      // console.log({previewDivs})
      this.createTimerange()
      this.createDashboardreqobj(previewDivs,false,true)
      return this.defaulttimerange
    }
    create_pipelistatreq(widgetkeys:any){
      let requestObj = {"dashboard_landing":false,"refresh":false,"userTimeZone":this.userTimeZone,"timeRange":this.requesttimerange}
      requestObj["widgetkeys"] = widgetkeys
      if(requestObj["widgetkeys"].length){
        this.requestDashboardData(requestObj);
      }
    }
    get_pipelineStat_labels(widgetkeys:any){
      this.createTimerange()
      this.create_pipelistatreq(widgetkeys)
      return this.defaulttimerange
    }

}
